import React from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {Env} from  "@morningtrain/helpers";
import useWillConstrain from "../hooks/use-will-constrain";

function EnvFilter(props) {

    const [value] = React.useState(Env.get(props.envKey));

    useWillConstrain(props.name, value)

    return null;
}

EnvFilter.propTypes = {
    name: PropTypes.string.isRequired,
    envKey: PropTypes.string.isRequired,
};

export default observer(EnvFilter);
